import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO fallbackTitle="Page not found | MIST Quality Inspection and Logistics" />
      <section className="bg-mist-navy text-white">
        <div className="container-mist pt-40 pb-24">
          <div className="eyebrow mb-4">404</div>
          <h1 className="font-display text-5xl lg:text-6xl leading-[1.05]">Page not found</h1>
          <div className="mt-6 gold-divider" />
          <p className="mt-6 text-base text-white/75 max-w-2xl">
            The page you're looking for doesn't exist or has moved.
          </p>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="mt-8 inline-flex items-center justify-center gap-2 bg-mist-gold text-mist-navy px-7 h-11 text-[11px] uppercase tracking-[0.22em] font-semibold rounded-md hover:bg-[#b8994f] transition-all duration-200 ease-out"
          >
            Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
